import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { authApi } from '../store/auth/authApi';
import { userAPI } from '../store/user/userApi';
import { userDomAPI } from '../store/user/userDomApi';
import userAccessSlice from '../store/brokers/partners/user-access-control/userAccessSlice';
import partnersSlice from '../store/brokers/partners/partners/partnersSlice';
import historyChatsSlice from '../store/brokers/partners/history-chats/historyChatsSlice';
import featuresReducer from '../store/features/featuresSlices';
import { chatboxApi } from '../store/chatbox/chatboxApi';
import notificationsSlice from '../store/brokers/partners/notifications/notificationsSlice';
import aiModelsSlice from '../store/brokers/partners/ai-models/aiModelsSlice';
import demoRequestsSlice from '../store/brokers/partners/demo-requests/requestsSlice';
import knowledgeBaseExceptionsSlice from '../store/sofia/exceptions/knowledgeBaseExceptionsSlice';
import knowledgeBaseNotificationsReducer from '../store/sofia/notifications/knowledgeBaseNotificationsSlice';
import { marketingApi } from '../store/marketing/marketingApi';
import costsSlice from '../store/costs/costsSlice';
import { usersApi } from '../store/users/usersApi';
import subscriptionsSlice from '../store/subscriptions/subscriptionsSlice';
import { promptsApi } from '../store/prompts/promptsApi';


export const store = configureStore({
    reducer: {
        [userAPI.reducerPath]: userAPI.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [userDomAPI.reducerPath]: userDomAPI.reducer,
        [chatboxApi.reducerPath]: chatboxApi.reducer,
        [marketingApi.reducerPath]: marketingApi.reducer,
        [usersApi.reducerPath]: usersApi.reducer,
        [promptsApi.reducerPath]: promptsApi.reducer,
        userAccess: userAccessSlice,
        partners: partnersSlice,
        history: historyChatsSlice,
        features: featuresReducer,
        notifications: notificationsSlice,
        aiModels: aiModelsSlice,
        demoRequests: demoRequestsSlice,
        knowledgeBaseExceptionsSlice: knowledgeBaseExceptionsSlice,
        knowledgeBaseNotifications: knowledgeBaseNotificationsReducer,
        clientCosts: costsSlice,
        leoSubscriptions: subscriptionsSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            userAPI.middleware,
            authApi.middleware,
            userDomAPI.middleware,
            chatboxApi.middleware,
            marketingApi.middleware,
            usersApi.middleware,
            promptsApi.middleware,
        ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
